import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import moment from "moment-timezone";
import Framework from "@beardeddevops/react.framework";

const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const COLORS = [
	"#6FAED9",
	"#9B7AF2",
	"#F58ACB",
	"#D7F27A",
	"#F8A37B",
	"#F6DB7A",
	"#7D89E8",
	"#D58AE8",
	"#E3A072",
	"#7FE0A6",
	"#E6C96F",
	"#D8F5A2",
	"#FBC2D9",
	"#AED9E0",
	"#CDB4DB",
	"#FFC8A2",
	"#BEE7A5",
	"#FFD6E0",
	"#E4E4A8",
	"#C7EDE6",
	"#F1E1C6",
	"#D0E1FF",
	"#FFE5A8"
];


const START_HOUR = 5;
const END_HOUR = 22;
const NAME_COL_WIDTH = 180;
const SIDEBAR_WIDTH = 220;
const ROW_HEIGHT = 42;
const TIMEZONE = "America/Phoenix";


const parseTimeToMinutes = (timeStr) => {
	const m = moment(timeStr, ["hA", "h:mmA"]);
	return m.hours() * 60 + m.minutes();
};

const parseRangeToMinutes = (range) => {
	const [start, end] = range.split("-");
	return {
		startMin: parseTimeToMinutes(start),
		endMin: parseTimeToMinutes(end)
	};
};


class SchedulesComponent extends Framework.Components.Collection {
	constructor(props) {
		const model = new API.BuildClass(
			Types.Schedules._name,
			API.RequestType.READ_ALL
		);
		super(props, model);
		this.request = this.props.override;

		this.timelineRef = React.createRef();

		this.state = {
			rows: [],
			linePx: null,
			timelineWidth: 0,
			hoveredKey: null,
		};
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.fetchData(this.state);

		this.measureTimeline();
		this.updateLinePosition();

		this.interval = setInterval(this.updateLinePosition, 60000);
		window.addEventListener("resize", this.measureTimeline);
	}

	componentWillUnmount() {
		clearInterval(this.interval);
		window.removeEventListener("resize", this.measureTimeline);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.data?.length && prevState.data !== this.state.data) {
			this.buildRows();
		}

		if (
			prevProps.currentDay !== this.props.currentDay ||
			prevProps.currentView !== this.props.currentView
		) {
			this.buildRows();
		}
		if (prevProps.currentView !== this.props.currentView) {
			if (this.props.currentView === "day") {
				this.updateLinePosition();
			} else {
				this.setState({linePx: null});
			}
		}

	}


	fetchData = async (state) => {
		this.state.sorted = [];
		this.state.page = 0;
		this.state.search = "";
		if (typeof this.state.filter === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.type = this.props.type;
		this.state.filter.filterWeek = this.props.filterWeek;
		this.setState({loading: true});
		window.setTimeout(() => this.fetchDataActual(state), 100);
	};

	setHover = (key) => {
		this.setState({hoveredKey: key});
	};

	clearHover = () => {
		this.setState({hoveredKey: null});
	};

	buildDayRows = (day) => {
		const rows = [];

		this.state.data.forEach((item, index) => {

			const schedule = item.data_obj ? JSON.parse(item.data_obj) : [];
			const dayEntry = schedule.find(d => d.day === day);
			if (!dayEntry) return;

			dayEntry.times.forEach(range => {
				const {startMin, endMin} = parseRangeToMinutes(range);

				rows.push({
					key: `${item.user}-${day}-${range}`,
					user: item.user_name,
					userPkey: item.user,
					color: COLORS[index % COLORS.length],
					startMin,
					endMin,
					label: range,
					day
				});
			});
		});

		rows.sort((a, b) => a.user.localeCompare(b.user));
		this.setState({rows});
	};

	buildWeekRows = () => {
		const weekRows = {};

		DAYS.forEach(d => (weekRows[d] = []));

		this.state.data.forEach((item, index) => {
			const schedule = item.data_obj ? JSON.parse(item.data_obj) : [];

			schedule.forEach(dayEntry => {
				if (!weekRows[dayEntry.day]) return;

				dayEntry.times.forEach(range => {
					const {startMin, endMin} = parseRangeToMinutes(range);

					weekRows[dayEntry.day].push({
						key: `${item.user}-${dayEntry.day}-${range}`,
						user: item.user_name,
						userPkey: item.user,
						color: COLORS[index % COLORS.length],
						startMin,
						endMin,
						label: range,
						day: dayEntry.day
					});
				});
			});
		});

		DAYS.forEach(d => {
			weekRows[d].sort((a, b) => a.user.localeCompare(b.user));
		});

		this.setState({weekRows});
	};


	buildRows = () => {
		const {currentDay, currentView} = this.props;

		if (currentView === "day") {
			this.measureTimeline();
			this.buildDayRows(currentDay);
			return;
		}

		this.buildWeekRows();
	};


	measureTimeline = () => {
		if (this.props.currentView !== "day") return;

		if (this.timelineRef.current) {
			this.setState({
				timelineWidth: this.timelineRef.current.clientWidth
			});
		}
	};


	updateLinePosition = () => {
		if (this.props.currentView !== "day") {
			if (this.state.linePx !== null) {
				this.setState({linePx: null});
			}
			return;
		}

		const COLUMN_WIDTH = this.state.timelineWidth / 18;
		const now = moment.tz(TIMEZONE);
		const hours = now.hour() - START_HOUR;
		const minutes = now.minute();

		if (minutes < 0 || hours < 0) {
			this.setState({linePx: null});
			return;
		}

		this.setState({
			linePx: hours * COLUMN_WIDTH + (minutes / 60) * COLUMN_WIDTH
		});
	};


	getWorkingNow = () => {
		const now = moment.tz(TIMEZONE);
		const nowMin = now.hour() * 60 + now.minute();

		return this.state.rows.filter(
			r => nowMin >= r.startMin && nowMin <= r.endMin
		);
	};


	render() {
		const {rows, linePx, timelineWidth} = this.state;
		const COLUMN_WIDTH = timelineWidth / 18;
		const workingNow = this.getWorkingNow();
		const isDayView = this.props.currentView === "day";

		return (
			<div style={{display: "flex"}}>
				<div style={{flex: 1, position: "relative"}} key={this.props.currentView}>

					{isDayView ? (
						<>
							{/* ===== DAY VIEW ===== */}

							{/* HEADER */}
							<div
								style={{
									display: "grid",
									gridTemplateColumns: `${NAME_COL_WIDTH}px 1fr`,
									borderBottom: "1px solid #ccc"
								}}
							>
								<div/>
								<div ref={this.timelineRef} style={{display: "flex"}}>
									{Array.from({length: END_HOUR - START_HOUR + 1}).map((_, i) => {
										const h = START_HOUR + i;
										return (
											<div
												key={h}
												style={{
													flex: 1,
													textAlign: "left",
													fontSize: 12,
													borderLeft: "1px solid #ddd"
												}}
											>
												{h > 12 ? h - 12 : h}
												{h < 12 ? "AM" : "PM"}
											</div>
										);
									})}
								</div>
							</div>

							{/* GRID */}
							<div style={{position: "relative"}}>
								{/* GRID LINES */}
								<div
									style={{
										position: "absolute",
										left: NAME_COL_WIDTH,
										right: 0,
										top: 0,
										bottom: 0,
										display: "flex",
										zIndex: 1
									}}
								>
									{Array.from({length: END_HOUR - START_HOUR + 1}).map((_, i) => (
										<div key={i} style={{flex: 1, borderLeft: "1px solid #eee"}}/>
									))}
								</div>

								{/* NOW LINE */}
								{linePx !== null && (
									<div
										style={{
											position: "absolute",
											top: 0,
											bottom: 0,
											left: NAME_COL_WIDTH + linePx,
											width: 2,
											background: "red",
											zIndex: 2
										}}
									/>
								)}

								{/* ROWS */}
								{rows.map((row, idx) => {
									const startPx = (row.startMin / 60 - START_HOUR) * COLUMN_WIDTH;
									const widthPx = ((row.endMin - row.startMin) / 60) * COLUMN_WIDTH;
									const isHovered = this.state.hoveredKey === row.key;

									return (
										<div
											key={row.key || `${row.user}-${idx}`}
											style={{
												display: "grid",
												gridTemplateColumns: `${NAME_COL_WIDTH}px 1fr`,
												height: ROW_HEIGHT,
												position: "relative",
												zIndex: 3
											}}
										>
											{(this.props.rootState.main_role ?? 10) <= 20 ? <a
												style={{
													paddingLeft: 10,
													display: "flex",
													alignItems: "center",
													fontSize: 13
												}}
												href={`/users/${row.userPkey}`}
												target={"_blank"}
											>
												{row.user}
											</a> : <b style={{
												paddingLeft: 10,
												display: "flex",
												alignItems: "center",
												fontSize: 13
											}}>
												{row.user}
											</b>}

											<div style={{position: "relative"}}>
												<div
													style={{
														position: "absolute",
														left: startPx,
														width: widthPx,
														top: 6,
														bottom: 6,
														background: row.color,
														borderRadius: 6,
														display: "flex",
														alignItems: "center",
														paddingLeft: 8,
														fontSize: 11,
														fontWeight: 500,
														whiteSpace: "nowrap",
														outline: isHovered ? "2px solid #000" : "none",
														boxShadow: isHovered ? "0 0 0 3px rgba(0,0,0,0.15)" : "none",
														transform: isHovered ? "scaleY(1.05)" : "none",
														zIndex: isHovered ? 10 : 3,
														cursor: "pointer"
													}}
													onMouseEnter={() => this.setHover(row.key)}
													onMouseLeave={this.clearHover}
												>
													{row.label}
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</>
					) : (
						<div
							style={{
								display: "grid",
								gridTemplateColumns: "repeat(7, 1fr)",
								gap: 12,
								padding: 12
							}}
						>
							{DAYS.map(day => {
								const dayRows = this.state.weekRows?.[day] || [];
								const isToday = day === moment.tz(TIMEZONE).format("dddd");


								return (
									<div
										key={day}
										style={{
											border: isToday ? "2px solid #2B81C2" : "1px solid #ddd",
											borderRadius: 8,
											padding: 8,
											background: isToday ? "#F3F8FF" : "#fff",
											minHeight: 120,
											boxShadow: isToday ? "0 0 0 2px rgba(43,129,194,0.15)" : "none"
										}}

									>
										{/* DAY HEADER */}
										<div
											style={{
												textAlign: "center",
												fontWeight: isToday ? 700 : 600,
												marginBottom: 6,
												paddingBottom: 4,
												borderBottom: isToday ? "2px solid #2B81C2" : "1px solid #eee",
												color: isToday ? "#2B81C2" : "#000"
											}}

										>
											{day}
										</div>

										{/* DAY CONTENT */}
										{dayRows.length === 0 ? (
											<div
												style={{
													fontSize: 12,
													color: "#999",
													textAlign: "center",
													marginTop: 8
												}}
											>
												No shifts
											</div>
										) : (
											dayRows.map(row => {
												const isHovered = this.state.hoveredKey === row.key;

												return (
													<div
														key={row.key}
														onMouseEnter={() => this.setHover(row.key)}
														onMouseLeave={this.clearHover}
														style={{
															marginTop: 6,
															padding: "6px 8px",
															borderRadius: 6,
															background: row.color,
															fontSize: 12,
															cursor: "pointer",

															outline: isHovered ? "2px solid #000" : "none",
															boxShadow: isHovered
																? "0 0 0 3px rgba(0,0,0,0.15)"
																: "none"
														}}
													>
														<a href={`/users/${row.userPkey}`} target={"_blank"}>
															<div style={{fontWeight: 600}}>
																{row.user}
															</div>
															<div style={{fontSize: 11}}>
																{row.label}
															</div>
														</a>
													</div>
												);
											})
										)}
									</div>
								);
							})}
						</div>

					)}
				</div>

				{/* SIDEBAR */
				}
				{this.props.filterWeek && this.props.filterWeek === moment().day(0).format("YYYY-MM-DD") && <div
					style={{
						width: SIDEBAR_WIDTH,
						borderLeft: "1px solid #ddd",
						padding: 10,
						background: "#fafafa"
					}}
				>
					<>
						<h4>Working Now ({workingNow.length})</h4>
						<b>AZ Time – {moment.tz(TIMEZONE).format("h:mm A")}</b>

						{workingNow.map((p) => {
							const isHovered = this.state.hoveredKey === p.key;

							return (
								<div
									key={p.key}
									onMouseEnter={() => this.setHover(p.key)}
									onMouseLeave={this.clearHover}
									style={{
										padding: "6px 8px",
										marginBottom: 6,
										borderRadius: 6,
										background: p.color,
										fontSize: 13,
										outline: isHovered ? "2px solid #000" : "none",
										boxShadow: isHovered ? "0 0 0 3px rgba(0,0,0,0.15)" : "none",
										cursor: "pointer"
									}}
								>
									{p.user} ({p.label})
								</div>
							);
						})}
					</>
				</div>}
			</div>
		)
			;
	}

}

export default Framework.Components.withRootState(SchedulesComponent);
